<template>
  <div>
    <div
      class="
        tw-overflow-hidden
        tw-rounded-lg
        tw-border
        tw-border-solid
        tw-border-sf-slate-lighter-1
        tw-bg-white
      "
    >
      <div
        class="
          tw-flex
          tw-items-center
          tw-justify-between
          tw-border-x-0
          tw-border-b
          tw-border-t-0
          tw-border-solid
          tw-border-sf-slate-lighter-1
          tw-px-6
          tw-py-4
        "
        data-testid="groups-tab-toolbar"
      >
        <div class="tw-w-[250px]" data-testid="groups-tab-search">
          <SfSearchInput
            :model-value="search ?? ''"
            :show-result-navigation="false"
            :placeholder="I18n.t('group.table.search_placeholder')"
            @update:model-value="setSearch($event ?? '')"
            @clear="setSearch('')"
          />
        </div>
        <SfButtonDs
          variant="primary"
          icon-before="plus"
          data-testid="groups-tab-add"
          @click="groupPanel.openNew()"
        >
          {{ I18n.t('user.add_group') }}
        </SfButtonDs>
      </div>
      <div
        v-if="loading"
        class="tw-flex tw-flex-col tw-gap-4 tw-px-4 tw-py-6"
        data-testid="groups-tab-loading"
      >
        <SfSkeletonLoader
          v-for="placeholder in SKELETON_ROWS"
          :key="placeholder"
          width="100%"
          height="1.5rem"
        />
      </div>
      <div
        v-else-if="error"
        class="tw-px-4 tw-py-6 tw-text-sm tw-text-sf-slate-dark-1"
        data-testid="groups-tab-error"
      >
        {{ I18n.t('group.table.load_error') }}
      </div>
      <EmptyState
        v-else-if="groups.length === 0"
        :text="
          search
            ? I18n.t('group.table.no_search_results')
            : I18n.t('user.empty_states.groups')
        "
      />
      <GroupsTable
        v-else
        :rows="groups"
        :sort-by="sortBy"
        :sort-direction="sortDirection"
        @sort="setSort($event)"
        @open="groupPanel.open($event)"
      />
      <div
        class="
          tw-border-x-0
          tw-border-b-0
          tw-border-t
          tw-border-solid
          tw-border-sf-slate-lighter-1
          tw-py-5
        "
        data-testid="groups-tab-footer"
      >
        <SfPaginationDs
          v-if="totalPages > FIRST_PAGE"
          :current-page="page"
          :total-pages="totalPages"
          data-testid="groups-tab-pagination"
          @change-page="setPage"
        />
      </div>
    </div>

    <GroupPanel @saved="reload" />
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'

import {
  FIRST_PAGE,
  SKELETON_ROWS,
} from '@app/application/user-management/constants'
import { useGroupPanelStore } from '@app/application/user-management/stores/group-panel'
import { useGroupsListStore } from '@app/application/user-management/stores/groups-list'
import useI18n from '@app/shared/vue/composables/use-I18n'
import EmptyState from '@app/shared/vue/components/molecules/empty-state.vue'
import GroupPanel from './group-panel.vue'
import GroupsTable from './groups-table.vue'
import { SfButtonDs } from '@silverfin/ui-components'
import SfPaginationDs from '@app/shared/vue/components/sf-pagination/sf-pagination-ds.vue'
import SfSearchInput from '@app/shared/vue/components/sf-search/search-input.vue'
import SfSkeletonLoader from '@app/shared/vue/components/sf-skeleton-loader.vue'

defineOptions({ name: 'GroupsTab' })

const I18n = useI18n()

const groupsList = useGroupsListStore()

const {
  groups,
  totalPages,
  loading,
  error,
  search,
  sortBy,
  sortDirection,
  page,
} = storeToRefs(groupsList)
const { setSearch, setSort, setPage, reload } = groupsList

const groupPanel = useGroupPanelStore()

groupsList.initialize()
</script>
